/* eslint-disable */
import React, { useState } from "react";
import {
  Card,
  Text,
  Badge,
  Button,
  Group,
  Stack,
  Avatar,
  Loader,
} from "@mantine/core";
import { IconClock } from "@tabler/icons-react";
import { getInitials } from "utils/getInitials";
import { Location, useAddPunchIn } from "api/attendance/punchIn";
import { useGetTimeUtilization } from "api/attendance/gettodayTimeUtilization";
import { getCurrentLocation } from "utils/devicegeolocation";
import { getDeviceId } from "utils/deviceid";
import PunchOutModal from "features/attendance-employees/components/punchOutModal";

interface PunchCardProps {
  firstName?: string;
  lastName?: string;
  dateTime?: string;
  productionHours?: string;
  clockInTime?: string;
  avatarUrl?: string;
}

const PunchCard: React.FC<PunchCardProps> = ({ ...props }) => {
  const { data, isLoading } = useGetTimeUtilization();
  const { mutateAsync: addPunchIn, data: punchInResponse } = useAddPunchIn();
  const [opened, setOpened] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);

  const canPunchOut = data?.data?.canPunchOut ?? false;
  const punchInTime = data?.data?.punchInTime || "";
  let buttonContent;
  if (loadingAction) {
    buttonContent = <Loader size="xs" />;
  } else if (canPunchOut) {
    buttonContent = "Clock Out";
  } else {
    buttonContent = "Clock In";
  }
  const timeString = new Date(punchInTime).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const handlePunchIn = async () => {
    setLoadingAction(true);
    try {
      const timestamp = new Date().toISOString();

      const deviceId = getDeviceId();

      let location: Location = { lat: 0, lng: 0 };

      try {
        const { lat, lng } = await getCurrentLocation();
        location = { lat, lng };
      } catch (geoError) {
        console.log(geoError);
      }
      const payload = {
        punchInTime: timestamp,
        source: "Web",
        deviceId,
        location,
      };

      await addPunchIn(payload);
    } catch (err) {
      console.error("Clock In Failed:", err);
    } finally {
      setLoadingAction(false);
    }
  };
  return (
    <>
      <Card
        shadow="sm"
        radius="md"
        withBorder
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack align="center" spacing="lg" sx={{ width: "100%" }}>
          <Text size="xs" color="dimmed">
            Good Morning, {props.firstName}
          </Text>
          <Text fw={700} size="md">
            {props.dateTime}
          </Text>
          <Avatar size={80} radius="xl">
            {getInitials(props?.firstName ?? "", props?.lastName ?? "")}
          </Avatar>
          <Badge color="grape" variant="filled">
            Production : {props?.productionHours ?? "0"}
          </Badge>
          <Group spacing={6}>
            <IconClock size={14} />
            <Text size="xs">Clock In Time {canPunchOut ? timeString : ""}</Text>
          </Group>
          <Button
            fullWidth
            variant="filled"
            color="dark"
            size="sm"
            onClick={canPunchOut ? () => setOpened(true) : handlePunchIn}
            disabled={loadingAction}
          >
            {buttonContent}
          </Button>
        </Stack>
      </Card>
      <PunchOutModal opened={opened} onClose={() => setOpened(false)} />
    </>
  );
};
export default PunchCard;
